import React from 'react';
import { siteContent } from '../content/siteContent';

const SocialProof = () => {
  const { socialProof } = siteContent;

  return (
    <section id="social-proof" className="social-proof" aria-label={socialProof.ariaLabel}>
      <div className="container">
        <ul className="proof-strip">
          {socialProof.badges.map((badge) => (
            <li key={badge.value} className="proof-badge">
              <strong>{badge.value}</strong>
              <span>{badge.label}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default SocialProof;
